export class KafkaSecurityConfigInputTlsSecret {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "SecretRefInputAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "SecretRefInputGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSecurityConfigInputTlsSecret.attributeTypeMap;
    }
    constructor() {
    }
}
